var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"qi-logo"},[_c('a',{staticClass:"pointer logo",on:{"click":function($event){return _vm.goTo('/')}}},[_c('img',{attrs:{"src":require("@/assets/qi-logo-branco.svg"),"alt":"Logo QI"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }